module.exports = __webpack_public_path__ + "static/brick-main-9d41b0330debc2c9e2c3fae226e52e6a.gif";